import { render, staticRenderFns } from "./table-layout.vue?vue&type=template&id=bf32b060&scoped=true"
import script from "./table-layout.vue?vue&type=script&lang=js"
export * from "./table-layout.vue?vue&type=script&lang=js"
import style0 from "./table-layout.vue?vue&type=style&index=0&id=bf32b060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf32b060",
  null
  
)

export default component.exports